$.fn.ensureMatches = function(errorMessage) {
    if (!$(this).length) {
        console && console.warn(errorMessage || '"' + this.selector + '" did not match any elements.');
    }

    return this;
};
